import { useCallback, useEffect, useState } from 'react';
import Switch from './Switch';
import {
  HOME_BACKGROUND_SETTING_EVENT,
  HOME_BACKGROUND_STORAGE_KEY,
  isHomeBackgroundEnabled,
  setHomeBackgroundEnabled,
} from 'src/utils/audio';

const HomeBackgroundSwitch = () => {
  const [isEnabled, setIsEnabled] = useState(() => isHomeBackgroundEnabled());

  useEffect(() => {
    const syncSwitchState = () => {
      setIsEnabled(isHomeBackgroundEnabled());
    };

    const handleStorage = (event) => {
      if (
        event.key &&
        event.key !== HOME_BACKGROUND_STORAGE_KEY
      ) {
        return;
      }

      syncSwitchState();
    };

    window.addEventListener('storage', handleStorage);
    window.addEventListener(
      HOME_BACKGROUND_SETTING_EVENT,
      syncSwitchState
    );

    return () => {
      window.removeEventListener('storage', handleStorage);
      window.removeEventListener(
        HOME_BACKGROUND_SETTING_EVENT,
        syncSwitchState
      );
    };
  }, []);

  const handleClickSwitch = useCallback(() => {
    setIsEnabled((currentValue) => {
      const nextValue = !currentValue;
      setHomeBackgroundEnabled(nextValue);
      return nextValue;
    });
  }, []);

  return (
    <div className="mic_permission home_background_switch">
      <p className="title">
        배경음
        <br />
        재생
      </p>
      <Switch
        isOn={isEnabled}
        onClick={handleClickSwitch}
        highlightWhenOff={false}
        inputLabel="배경음 재생"
      />
    </div>
  );
};

export default HomeBackgroundSwitch;
